import { useContext, useEffect, useState } from 'react';
import ItemCard from '../../../../../../components/itemCard';
import GlobalContext from '../../../../../../context/globalContext';
import { useToast } from '../../../../../../context/toast';
import {
  useGetSettings,
  useUpdateSettingsData,
} from '../../../../../../services/settings';
import Button from '../../../../../../components/button';
import Input from '../../../../../../components/input';
import { Modal } from '../../../../../../components/modal';
import build from './build';

const URL = () => {
  const { data, refetch } = useGetSettings();
  const figurData = data?.data.figur;
  const [open, setOpen] = useState(false);
  const { mutate, isLoading } = useUpdateSettingsData();
  const [url, setUrl] = useState<string>('');
  const { deviceDetails, setDeviceDetails, cardType } =
    useContext(GlobalContext);
  const { addToast } = useToast();

  const submit = () => {
    mutate(
      {
        figur: {
          ...figurData,
          android:
            cardType === 'android'
              ? { ...figurData?.android, url: url }
              : figurData?.android,
          ios:
            cardType === 'ios'
              ? { ...figurData?.ios, url: url }
              : figurData?.ios,
        },
      },
      {
        onSuccess: () => {
          refetch();
          setOpen(false);
          addToast({ msg: 'Successfully Updated', type: 'success' });
          setDeviceDetails({ ...deviceDetails, url: url });
        },
      }
    );
  };

  useEffect(() => {
    if (deviceDetails) {
      setUrl(deviceDetails.url);
    }
  }, [deviceDetails, setUrl]);

  return (
    <div>
      <div onClick={() => setOpen(true)}>
        <ItemCard title="URL" hint={deviceDetails.url} />
      </div>

      <Modal
        padding={true}
        isVisible={open}
        center
        close={setOpen}
        title="URL"
        header={true}
        width="medium"
        showFooter
        footer={
          <div className="flex justify-end">
            <Button onClick={submit} loading={isLoading} disabled={isLoading}>
              Save Changes
            </Button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <div className="flex justify-between">
              <h5>Enter Url</h5>
            </div>
            <Input
              parentClassName="mt-2"
              defaultValue={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default URL;
